import React, { Component } from 'react';
import { Formik } from 'formik';
import { Space, Button, Form, Alert } from "antd";
import * as Yup from 'yup';
import * as constants from '../../constants';

import common from '../../../../common';
import core from '../../../core';


const { TextInput, NumberInput, DisplayFormikState } = core;

const FormItem = Form.Item;

const FormSchema = Yup.object().shape({
    name: Yup.string().required('*'),
    retentionPeriod: Yup.string().required('*'),
});

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 4,
        },
    },
};

class InformationCarrierForm extends Component {

    onSave = async (values, { setSubmitting, setErrors }) => {
        if (this.props.onSave) {
            await this.props.onSave(values);
            setSubmitting(false);
        } else {
            setSubmitting(false)
        }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'InformationCarrierForm', key);
    }

    CreateForm = (props) => {
        //console.log(props);
        const userHasReadonlyRights = false; //!this.props.currentUsersCompanyRights.includes(common.rights.BedrijfMuteren);

        return (
            <Form layout='horizontal' style={{ margin: 10 }}>
                <TextInput {...props} name="name" readOnly={userHasReadonlyRights} label={this.label("Name")} formItemLayout={formItemLayout} />
                <TextInput {...props} name="retentionPeriod" readOnly={userHasReadonlyRights} label={this.label("RetentionPeriod")} formItemLayout={formItemLayout} />
                <FormItem {...tailFormItemLayout}>
                    <Space.Compact className='entity-form-btns'>
                        <Button disabled={props.isSubmitting || userHasReadonlyRights} onClick={this.props.onCancel}>{this.label("Cancel")} </Button>
                        <Button type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting || userHasReadonlyRights} > {this.label("Save")} </Button>
                    </Space.Compact>
                </FormItem>
                {props.isSubmitting &&
                    <Alert
                        message={this.label("Saving")}
                        style={{ marginTop: 20 }}
                    />
                }
                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true}
                initialValues={this.props.datacontext}
                validationSchema={FormSchema}
                onSubmit={this.onSave}
                render={this.CreateForm}
            />
        );
    }
}

export default InformationCarrierForm